import axios from 'axios'

export const getAccountMappings = (params) => {
  return axios.get(`/finance/accountMappings`, { params })
}

export const editAccountMapping = (data) => {
  return axios.put(`/finance/accountMappings`, data)
}
